import styled from 'styled-components'

export const Container = styled.div<{ $fullWidth: boolean }>`
  padding-bottom: 16px;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
`
